import React from 'react';
import Flashcards from './Flashcards';
import eventsData from '../data/events.json';

const FlashcardsPage = () => {
  return <Flashcards events={eventsData} />;
};

export default FlashcardsPage;
